import { createWithEqualityFn } from 'zustand/traditional';
import { CalendarNavigationStore } from './calendarNavigationStore.types';

export const useCalendarNavigationStore =
  createWithEqualityFn<CalendarNavigationStore>((set) => ({
    position: undefined,
    event: undefined,
    calendarEvents: {},
    control: {
      setPosition: (position) => {
        set((state) => {
          return {
            ...state,
            position
          };
        });
      },
      setCalendarEvents: (calendarId, calendarEvents) => {
        set((state) => {
          return {
            ...state,
            calendarEvents: {
              ...state.calendarEvents,
              [calendarId]: calendarEvents
            }
          };
        });
      },
      removeCalendarEventsForCalendarIds: (calendarIds: string[]) => {
        set((state) => {
          const filteredCalendarEvents = Object.fromEntries(
            Object.entries(state.calendarEvents).filter(
              ([calendarId]) => !calendarIds.includes(calendarId)
            )
          );

          return {
            ...state,
            calendarEvents: filteredCalendarEvents
          };
        });
      },
      setEvent: (event) => {
        set((state) => {
          return {
            ...state,
            event
          };
        });
      }
    }
  }));
